import React, { useState } from 'react';
import { Outlet, Link } from 'react-router-dom';
import { Menu, ArrowLeft, LogOut } from 'lucide-react';
import { base44 } from '@/api/base44Client';
import { useAuth } from '@/lib/AuthContext';
import AdminSidebar from '@/components/admin/AdminSidebar';

// Dedicated shell for all /admin/* pages: a persistent grouped sidebar +
// slim top bar with back-to-site and sign out. Public Navbar/Footer are not
// rendered here so the admin area is uncluttered.
export default function AdminLayout() {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();

  return (
    <div className="min-h-screen bg-[#0d0d0f]">
      <AdminSidebar open={open} onClose={() => setOpen(false)} />

      {/* Top bar */}
      <header className="fixed top-0 left-0 lg:left-64 right-0 h-16 bg-[#0d0d0f]/90 backdrop-blur border-b border-white/5 z-30 flex items-center justify-between px-4 lg:px-6">
        <div className="flex items-center gap-3">
          <button
            onClick={() => setOpen(true)}
            className="lg:hidden text-white/60 hover:text-white transition-colors"
            aria-label="Open menu"
          >
            <Menu className="w-5 h-5" />
          </button>
          <Link
            to="/"
            className="flex items-center gap-2 text-white/40 hover:text-white text-xs font-bold tracking-wider transition-colors"
          >
            <ArrowLeft className="w-4 h-4" /> BACK TO SITE
          </Link>
        </div>
        <div className="flex items-center gap-4">
          {user?.email && (
            <span className="text-white/40 text-xs hidden sm:block truncate max-w-[200px]">
              {user.email}
            </span>
          )}
          <button
            onClick={() => base44.auth.logout('/')}
            className="flex items-center gap-1.5 text-white/50 hover:text-white text-xs font-bold tracking-wider transition-colors"
          >
            <LogOut className="w-3.5 h-3.5" /> SIGN OUT
          </button>
        </div>
      </header>

      <main className="lg:pl-64">
        <Outlet />
      </main>
    </div>
  );
}